/**
 * ApprovalHistory - Wrapper page for viewing manager approval/rejection audit trail
 * Shows the ApprovalHistoryTable with full filtering capabilities.
 * Supports embedded mode for use inside the Reports tab view.
 */
import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import ApprovalHistoryTable from './components/ApprovalHistoryTable';

interface ApprovalHistoryProps {
  embedded?: boolean;
}

const ApprovalHistory: React.FC<ApprovalHistoryProps> = ({ embedded = false }) => {
  const { t } = useLanguage();

  return (
    <div className={embedded ? 'space-y-6' : 'p-6 max-w-[1600px] mx-auto'}>
      {/* Header - hidden when embedded in Reports page */}
      {!embedded && (
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            {t('approvalHistory.title')}
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
            {t('approvalHistory.subtitle')}
          </p>
        </div>
      )}

      <ApprovalHistoryTable />
    </div>
  );
};

export default ApprovalHistory;
